<app-loading-panel [showLoading]="!langLoaded || (storeViewState$ | async)?.state === 'LOADING'" [hideText]="false"
  [isSmall]="true"></app-loading-panel>
<div [ngClass]="{'d-none': !langLoaded || (storeViewState$ | async)?.state === 'LOADING'}"
  [ngSwitch]="(storeViewState$ | async)?.state"
  [ngStyle]="{'padding-bottom.px': showCookieConfirmation ? cookieBarHeight : 0, 'height': '100%'}"
  (window:resize)="calcViewPortHeight()" (click)="hideCookieFixedMessage()">
  <app-store-dashboard [acceptTermVisible]="showCookieConfirmation" *ngSwitchCase="'LOADED'"
    class="theme-interface"></app-store-dashboard>
  <app-store-item-details *ngSwitchCase="'VIEWPRODUCTDETAILS'" class="theme-interface"></app-store-item-details>
  <app-store-item-details *ngSwitchCase="'VIEWPRODUCTDETAILSFROMCARTVIEW'"
    class="theme-interface"></app-store-item-details>
  <app-store-customer-login *ngSwitchCase="'LOGIN'" class="theme-interface"></app-store-customer-login>
  <app-store-checkout *ngSwitchCase="'VIEWCART'" class="theme-interface"></app-store-checkout>
  <app-store-checkout-payment *ngSwitchCase="'CHECKOUT'" class="theme-interface"></app-store-checkout-payment>
  <app-store-thank-you *ngSwitchCase="'THANKYOUPAGE'" class="theme-interface"></app-store-thank-you>
  <app-store-error *ngSwitchCase="'ERRORPAGE'" class="theme-interface"></app-store-error>
  <app-store-empty-cart *ngSwitchCase="'EMPTYCARTPAGE'" class="theme-interface"></app-store-empty-cart>
  <app-standalone-payment *ngSwitchCase="'STANDALONEPAYMENT'"></app-standalone-payment>
  <app-payment-progress *ngSwitchCase="'PAYMENTPROGRESS'"></app-payment-progress>
  <app-store-payment-pay *ngSwitchCase="'PAYMENTPAY'"></app-store-payment-pay>
  <app-qr-payment *ngSwitchCase="'QRCODEPAY'" class="theme-interface"></app-qr-payment>
  <app-store-customer-profile *ngSwitchCase="'PROFILE'" class="theme-interface"></app-store-customer-profile>
  <app-edit-profile *ngSwitchCase="'EDITPROFILE'" class="theme-interface"></app-edit-profile>
  <app-edit-address *ngSwitchCase="'EDITADDRESS'" class="theme-interface"></app-edit-address>
</div>
<div class="cookie-bar" *ngIf="showCookieConfirmation && !isIOSApp && langLoaded" #cookieBar
  (window:resize)="calcCookieBarHeight()" (resize)="calcCookieBarHeight()" [style.bottom.px]="customerFooterHeight"
  id="cookie-bar">
  <span>
    {{'public.store.cookie'|translate}}
    <br>
    <a role="button" class="cookie-button accept-button" (click)="onAcceptCookie()">
      {{'public.cookie.accept'|translate}}
    </a>
    <a role="button" class="cookie-button reject-button" (click)="onRejectCookie()">
      {{'public.cookie.reject'|translate}}
    </a>
    <a [href]="this.getCookieLink()" target="_blank" (click)="openReadMoreModal($event, 'cookie')"
      class="read-more-link">
      {{'public.cookie.readMore'|translate}}
    </a>
  </span>
</div>
<div id="sticky-cookie" class="sticky-cookie text-center pt-2 px-1 font-size-secondary bg-white"
  *ngIf="showCookieFixedMessage && !isIOSApp && langLoaded" [style.bottom.px]="customerFooterHeight"
  [ngStyle]="isGoApp ? {} : {'padding-bottom': 'var(--safe-area-inset-bottom, 0)'}">
  {{'public.global.cookies' | translate}}
</div>

<div class="readmore-selector-container d-flex flex-wrap justify-content-center align-items-center hide" #refEl
  #readMoreSelectorModal (click)="OnCheckOutsideClose()">
  <div class="selection-container p-4 position-absolute">
    <div class="header-container d-flex flex-wrap">
      <div class="w-100">
        <div class="text-center justify-content-center font-size-title">
          <span
            class="float-right position-absolute closebutton text-decoration-underline font-weight-bold theme-color-header">
            {{'public.global.close'
            | translate}}<i class="fas fa-times pl-2 theme-color-header"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="readmore-container container py-2">
      <iframe *ngIf="currentPopUpFrom === 'cookie'" frameborder="0" width="100%" height="600"
        [src]="this.getCookieLink() | safe "></iframe>
    </div>
  </div>
</div>